import { useMemo } from 'react'

import { Alert, Box } from '@mui/material'

import { ModalContent } from '@/components/Modal'
import { FormConfig } from '@workwave-tidal/core/form'

import { useOnSubmit } from '../../hooks/useOnSubmit'
import { useTexts } from '../../hooks/useTexts'

import { Footer } from '../Footer'
import { Header } from '../Header'
import { Password } from './components/fields/Password'

import { form } from '../../../formState'
import { ChangePasswordFormValues } from '../../../types'

export function Form() {
  const onSubmit = useOnSubmit()

  const texts = useTexts()

  const configs = useMemo<FormConfig<ChangePasswordFormValues>>(
    () => ({
      id: 'change-password-user-form',
      initialValues: { 'new-password': '' },
    }),
    [],
  )

  return (
    <ModalContent header={<Header />} maxWidth={600}>
      <Box height={380}>
        <form.Form
          config={configs}
          requireTransaction={false}
          stopEditingOnUnmount
          applyPendingFitMapOnMount={false}
          onSubmit={onSubmit}
          footer={<Footer />}
          disableScroll
          fieldsPadding="16px 0"
        >
          <form.Fieldset spacing={2}>
            <Password />
            <Alert severity="warning">{texts.warning}</Alert>
          </form.Fieldset>
        </form.Form>
      </Box>
    </ModalContent>
  )
}
